export default "__VITE_ASSET__DCewmmhK__";